import { createReducer, on } from '@ngrx/store';
import { initialPerfilState } from './perfil.state';
import * as PerfilActions from './perfil.actions';

export const perfilReducer = createReducer(
  initialPerfilState,

  // Load Perfiles
  on(PerfilActions.loadPerfiles, state => ({
    ...state,
    loading: true,
    error: null
  })),

  on(PerfilActions.loadPerfilesSuccess, (state, { perfiles }) => ({
    ...state,
    perfiles,
    loading: false,
    error: null
  })),

  on(PerfilActions.loadPerfilesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Create Perfil
  on(PerfilActions.createPerfil, state => ({
    ...state,
    creating: true,
    error: null
  })),

  on(PerfilActions.createPerfilSuccess, (state, { perfil }) => ({
    ...state,
    perfiles: [...state.perfiles, perfil],
    creating: false,
    error: null
  })),

  on(PerfilActions.createPerfilFailure, (state, { error }) => ({
    ...state,
    creating: false,
    error
  })),

  // Update Perfil
  on(PerfilActions.updatePerfil, state => ({
    ...state,
    updating: true,
    error: null
  })),

  on(PerfilActions.updatePerfilSuccess, (state, { perfil }) => ({
    ...state,
    perfiles: state.perfiles.map(p => (p.perfilId === perfil.perfilId ? perfil : p)),
    updating: false,
    error: null
  })),

  on(PerfilActions.updatePerfilFailure, (state, { error }) => ({
    ...state,
    updating: false,
    error
  })),

  // Delete Perfil
  on(PerfilActions.deletePerfil, state => ({
    ...state,
    deleting: true,
    error: null
  })),

  on(PerfilActions.deletePerfilSuccess, (state, { id }) => ({
    ...state,
    perfiles: state.perfiles.filter(p => p.perfilId !== id),
    deleting: false,
    error: null
  })),

  on(PerfilActions.deletePerfilFailure, (state, { error }) => ({
    ...state,
    deleting: false,
    error
  })),

  // Search Perfiles
  on(PerfilActions.searchPerfiles, (state, { query }) => ({
    ...state,
    searchQuery: query
  })),

  on(PerfilActions.searchPerfilesSuccess, (state, { results }) => ({
    ...state,
    searchResults: results
  })),

  on(PerfilActions.clearPerfilSearch, state => ({
    ...state,
    searchResults: [],
    searchQuery: ''
  })),

  // Select Perfil
  on(PerfilActions.selectPerfil, (state, { perfil }) => ({
    ...state,
    selectedPerfil: perfil
  })),

  // Clear Error
  on(PerfilActions.clearPerfilError, state => ({
    ...state,
    error: null
  }))
);
